<template>
    <v-slide-x-transition mode="out-in">
        <div v-if="showComponent">
            <v-main>
            <v-btn
                icon
                @click="sidebarDrawer = !sidebarDrawer"
                v-if="$vuetify.display.smAndDown && showSidebar && !sidebarDrawer"
                class="menu-button"
            >
                <v-icon>mdi-menu</v-icon>
            </v-btn>
            <!-- Sidebar -->
            <v-navigation-drawer
                v-if="showSidebar"
                class="leftSidebarPolicy"
                width="250"
                v-model="sidebarDrawer"
                :temporary="$vuetify.display.smAndDown"
                :permanent="!$vuetify.display.smAndDown"
                transition="slide-x-transition"
            >
                <!-- Top: Logo -->
                <router-link to="/" class="text-decoration-none">
                    <div class="pa-5 logo-section" style="cursor: pointer">
                        <h3 class="logo-title">{{ $t("logo.title") }}</h3>
                        <span class="logo-subtitle">{{
                            $t("logo.subtitle")
                        }}</span>
                    </div>
                </router-link>

                <v-divider />

                <!-- Middle: Header -->
                <div class="pa-5 text-center">
                    <h2 :title="sidebarHeader">{{ sidebarHeader }}</h2>
                    <span
                        >{{ $t("policyPages.lastUpdated") }}:
                        {{ updatedDate }}</span
                    >
                </div>

                <v-divider />

                <!-- Scrollable List Only -->
                <div class="scroll-area">
                    <v-list density="compact">
                        <v-list-item
                            v-for="(section, index) in sections"
                            :key="section.id"
                            :href="'#section-' + section.id"
                            class="pl-6"
                        >
                            <v-list-item-title>
                                {{ index + 1 }}. {{ section.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </div>

                <v-divider />
                <!-- Bottom: Fixed Links -->
                <SidebarLandingPageLinks />
            </v-navigation-drawer>

            <!-- Main Content -->
            
                <v-container>
                    <v-card class="pa-5 mb-5">
                        <v-card-title
                            class="text-h5 font-weight-bold text-center"
                        >
                            {{ pageTitle }}
                        </v-card-title>
                        <v-divider class="mb-4" />
                        <div
                            v-for="(section, index) in sections"
                            :key="section.id"
                            :id="'section-' + section.id"
                            class="mb-5"
                        >
                            <v-card-title class="text-h6 font-weight-bold">
                                {{ index + 1 }}. {{ section.title }}
                            </v-card-title>
                            <v-card-text v-html="section.content" />
                            <v-divider class="mb-4" />
                        </div>
                        {{ $t("policyPages.lastUpdated") }}: {{ updatedDate }}
                    </v-card>
                </v-container>
            </v-main>
        </div>
    </v-slide-x-transition>
</template>

<script>
import axios from "axios";
import emitter from "@/eventBus";
import SidebarLandingPageLinks from "./SidebarLandingPageLinks.vue";
import { showAlertModal } from "@/utils";

export default {
    name: "PolicyPage",
    components: {
        SidebarLandingPageLinks,
    },
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        pageTitle: {
            type: String,
            required: true,
        },
        sidebarHeader: {
            type: String,
            default: "",
        },
        showSidebar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showComponent: false,
            sections: [],
            updatedDate: "",
            sidebarDrawer: true,
        };
    },
    async created() {
        this.fetchSections();
    },
    mounted() {
        this.showComponent = true;
        this.sidebarDrawer = !this.$vuetify.display.smAndDown;
        emitter.on("language-changed", this.fetchSections);
    },
    beforeUnmount() {
        emitter.off("language-changed", this.fetchSections);
    },
    methods: {
        showAlertModal,
        async fetchSections() {
            try {
                const response = await axios.get(this.endpoint);
                this.sections = response.data;
                if (this.sections.length > 0) {
                    this.updatedDate = new Date(
                        this.sections[0].last_updated
                    ).toLocaleDateString();
                }
            } catch (error) {
                console.error(
                    `Error fetching sections from ${this.endpoint}:`,
                    error
                );
                this.showAlertModal(
                    this.$store,
                    this.$t("common.fetchSectionsFailed"),
                    "danger",
                    12000,
                error
                );
            }
        },
    },
};
</script>

<style scoped>
h2 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

.scroll-area {
    flex-grow: 1;
    overflow-y: auto;
    height: 55%;
    /* Hide scrollbars */
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.scroll-area::-webkit-scrollbar {
    display: none;
}

.menu-button {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 3000;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

</style>
